import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const NONE = { product_create: false, product_edit: false, product_delete: false, stock_adjust: false, lot_create: false, lot_edit: false, lot_delete: false };

export function useProductCapabilities() {
  const [caps, setCaps] = useState(NONE);
  useEffect(() => { api.get("/products-capabilities").then(setCaps).catch(() => setCaps(NONE)); }, []);
  return caps;
}
